import _debounce from "lodash/debounce";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
/**
 * A copy of react-resizable's ResizableBox but that will update state
 * when receiving new width / height props
 */


import React from 'react';
import PropTypes from 'prop-types';
import { Resizable } from 'react-resizable';

var ResizableColumn =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ResizableColumn, _React$Component);

  function ResizableColumn() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, ResizableColumn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = ResizableColumn.__proto__ || Object.getPrototypeOf(ResizableColumn)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "state", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: {
        width: _this.props.width,
        height: _this.props.height
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "adjustSize", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: _debounce(function (nextProps) {
        // This needs to be debounced otherwise performance issues galore
        if (nextProps.height !== _this.state.height || nextProps.width !== _this.state.width) {
          _this.setState({
            width: nextProps.width,
            height: nextProps.height
          });
        }
      }, 100)
    }), Object.defineProperty(_assertThisInitialized(_this), "setHeaderCellWidth", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(width) {
        _this.rowRef.style.width = width + 'px';
        _this.containerRef.style.width = width + 'px';
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "onResize", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event, _ref2) {
        var element = _ref2.element,
            size = _ref2.size;

        if (_this.rowRef && _this.containerRef) {
          _this.setHeaderCellWidth(size.width);
        }

        _this.props.onResize(event, {
          element: element,
          size: size
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "onResizeStop", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event, _ref3) {
        var element = _ref3.element,
            size = _ref3.size;

        _this.setState(size, function () {
          _this.props.onResizeStop(event, {
            element: element,
            size: size
          });
        });
      }
    }), _temp));
  }

  _createClass(ResizableColumn, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.width !== nextProps.width) {
        this.setHeaderCellWidth(nextProps.width);
      }

      this.adjustSize(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this; // Basic wrapper around a Resizable instance.
      // If you use Resizable directly, you are responsible for updating the child component
      // with a new width and height.


      var _props = this.props,
          handleSize = _props.handleSize,
          onResize = _props.onResize,
          onResizeStart = _props.onResizeStart,
          onResizeStop = _props.onResizeStop,
          draggableOpts = _props.draggableOpts,
          minConstraints = _props.minConstraints,
          maxConstraints = _props.maxConstraints,
          lockAspectRatio = _props.lockAspectRatio,
          props = _objectWithoutProperties(_props, ["handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio"]);

      return React.createElement("th", {
        width: this.props.width,
        ref: function ref(th) {
          return _this2.rowRef = th;
        }
      }, React.createElement(Resizable, {
        handleSize: handleSize,
        width: this.state.width,
        height: this.state.height,
        onResizeStart: onResizeStart,
        onResize: this.onResize,
        onResizeStop: this.onResizeStop,
        draggableOpts: draggableOpts,
        minConstraints: minConstraints,
        maxConstraints: maxConstraints,
        lockAspectRatio: lockAspectRatio
      }, React.createElement("div", _extends({
        style: {
          width: "".concat(this.state.width, "px"),
          height: "".concat(this.state.height, "px")
        },
        ref: function ref(div) {
          return _this2.containerRef = div;
        }
      }, props))));
    }
  }]);

  return ResizableColumn;
}(React.Component);

Object.defineProperty(ResizableColumn, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    height: PropTypes.number,
    width: PropTypes.number
  }
});
Object.defineProperty(ResizableColumn, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    handleSize: [20, 20],
    onResize: function onResize() {},
    onResizeStop: function onResizeStop() {}
  }
});
export { ResizableColumn as default };